import * as React from 'react'

import { searchesCount } from '../../../common/utils/tracking/trackSearchCount'
import SearchSurveyBanner from './searchSurveyBanner'

interface IProps {
  currentSite: string
  surveyUrl: string
}

const ThemeforestEaseOfUseSurvey: React.StatelessComponent<IProps> = props => {
  const { currentSite, surveyUrl } = props
  const shouldShowBanner =
    props.currentSite === 'themeforest' && searchesCount('themeforest') > 3

  if (!shouldShowBanner) {
    return null
  }

  return (
    <div className="tfEaseOfSurveyContainer">
      <SearchSurveyBanner
        siteId="tf"
        surveyUrl={props.surveyUrl}
        bannerText="How's your search going? Rewarding? Frustrating? We'd love to know."
      />
    </div>
  )
}

export default ThemeforestEaseOfUseSurvey



// WEBPACK FOOTER //
// ./client/components/banners/themeforestEaseOfUseSurvey.tsx